import React from 'react';
import { styled } from 'styled-components';

import { useSuggestionsContext } from 'Compass/contexts/SuggestionsContext';

const SuggestionPagination = () => {
  const suggestionsContext = useSuggestionsContext();

  const onPrevClick = () => {
    if (!suggestionsContext.firstPage) {
      void suggestionsContext.previousPage();
    }
  };

  const onNextClick = () => {
    if (suggestionsContext.moreSuggestions) {
      void suggestionsContext.nextPage();
    }
  }

  return <Container>
    <Arrow
      onClick={onPrevClick}
      $active={!suggestionsContext.firstPage}
    >&lt;</Arrow>
    <Arrow
      onClick={onNextClick}
      $active={suggestionsContext.moreSuggestions}
    >&gt;</Arrow>
  </Container>;
};

const Container = styled.div`
  display: flex;
  gap: 24px;
  background: #F8F9FC;
  padding: 12px 20px;
  border: 1px solid #E4E7EF;
  border-radius: 12px;
  margin-top: 16px;
  justify-content: space-between;
`;

const Arrow = styled.div<{$active: boolean}>`
  cursor: ${({$active}) => $active ? 'pointer' : 'not-allowed'};
  font-size: 18px;
  font-weight: 500;
  color: ${({$active}) => $active ? '#008AFF' : '#CDD1DC'};
  transition: color 0.15s ease;
  padding: 2px 8px;
  border-radius: 6px;

  &:hover {
    background: ${({$active}) => $active ? 'rgba(0, 138, 255, 0.06)' : 'transparent'};
  }
`;

export default SuggestionPagination;
